(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-b2b-registrierung"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-b2b-reg')) {
    class CustomB2bReg extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.status = this.querySelector('.custom-b2b-reg__status');
        this.statusIcon = this.status.querySelector('.custom-b2b-reg__status-icon');
        this.statusText = this.status.querySelector('.custom-b2b-reg__status-text');
        this.btn = this.querySelector('.custom-b2b-reg__btn');
        this.kontakt = this.dataset.kontakt || 'b2b@presch-tools.com';
        this.form.addEventListener('submit', (e) => this.senden(e));
        const ust = this.form.elements.ustid;
        ust.addEventListener('input', () => this.ustFormat(ust));
        ust.addEventListener('blur', () => this.ustFormat(ust, true));
        // Land (13.10.): steuert Muster und Hinweise der USt-IdNr., die PLZ-Länge und den Weg ohne Nummer.
        this.land = this.form.querySelector('select[name="land"]');
        if (this.land) this.land.addEventListener('change', () => this.landUmschalten());
        // Weg ohne USt-IdNr.: Häkchen blendet Steuernummer und Upload ein und nimmt die USt-IdNr. aus der Pflicht.
        this.ohne = this.form.elements.ohne_ustid;
        this.nachweis = this.querySelector('.custom-b2b-reg__nachweis');
        if (this.ohne) this.ohne.addEventListener('change', () => this.ohneUmschalten());
        // Standard-Hinweise merken, damit sie nach einem Fehler zurueckkommen.
        this.form.querySelectorAll('[data-hinweis]').forEach((h) => { h.dataset.standardText = h.textContent; });
        if (this.land) this.landUmschalten();
        this.form.querySelectorAll('input').forEach((i) => i.addEventListener('input', () => {
          if (i.name === 'ustid') return;
          const h = this.form.querySelector('[data-hinweis="' + i.name + '"]');
          this.feld(i.name, h ? h.dataset.standardText : '', '');
        }));
        // Auswahllisten zum Betrieb: Fehlerhinweis beim Auswählen zurücksetzen, „Sonstiges" blendet das Textfeld ein.
        this.form.querySelectorAll('select[name="gewerk"], select[name="mitarbeiter"], select[name="rolle"]').forEach((sel) => sel.addEventListener('change', () => {
          this.feld(sel.name, '', '');
          if (sel.name === 'gewerk') this.gewerkUmschalten();
        }));
      }

      // Gewerk „Sonstiges": kleines Textfeld einblenden und zur Pflicht machen; sonst bleibt es aus und wird nicht gesendet.
      gewerkUmschalten() {
        const sonst = this.form.elements.gewerk.value === 'Sonstiges';
        const wrap = this.form.querySelector('[data-gewerk-sonst]');
        const feld = this.form.elements.gewerk_sonst;
        wrap.hidden = !sonst;
        feld.disabled = !sonst;
        feld.required = sonst;
        if (sonst) feld.focus();
      }

      get landWert() { return (this.land && this.land.value) || 'DE'; }

      ustHinweis() {
        return this.landWert === 'AT'
          ? 'Deine UID steht auf jeder Rechnung: ATU und 8 Ziffern.'
          : 'Die Nummer steht auf jeder Rechnung: DE und 9 Ziffern.';
      }

      landUmschalten() {
        const at = this.landWert === 'AT';
        const ust = this.form.elements.ustid;
        const plz = this.form.elements.plz;
        ust.placeholder = at ? 'ATU12345678' : 'DE123456789';
        plz.maxLength = at ? 4 : 5;
        const hu = this.form.querySelector('[data-hinweis="ustid"]');
        if (hu) hu.dataset.standardText = this.ustHinweis();
        const hp = this.form.querySelector('[data-hinweis="plz"]');
        if (hp) hp.dataset.standardText = at ? '4 Ziffern, z. B. 1010.' : '';
        // Ohne USt-IdNr. nur in Deutschland: in Österreich ist die UID Pflicht für die steuerfreie Lieferung.
        if (this.ohne) {
          if (at && this.ohne.checked) { this.ohne.checked = false; this.ohneUmschalten(); }
          this.ohne.disabled = at;
          const kasten = this.ohne.closest('.custom-b2b-reg__check--ohne');
          if (kasten) kasten.hidden = at;
        }
        if (!(this.ohne && this.ohne.checked)) this.feld('ustid', this.ustHinweis(), '');
        this.feld('plz', at ? '4 Ziffern, z. B. 1010.' : '', '');
        if (ust.value) this.ustFormat(ust, true);
      }

      ustFormat(input, streng) {
        const roh = input.value.toUpperCase().replace(/[\s.\-]/g, '');
        if (roh !== input.value) input.value = roh;
        const at = this.landWert === 'AT';
        const muster = at ? /^ATU\d{8}$/ : /^DE\d{9}$/;
        if (!roh) return this.feld('ustid', this.ustHinweis(), '');
        if (muster.test(roh)) return this.feld('ustid', 'Passt.', 'ok');
        if (streng || roh.length >= 11) {
          if (!roh.startsWith(at ? 'ATU' : 'DE')) {
            if (!this.land) return this.feld('ustid', 'Aktuell nur für Betriebe aus Deutschland (DE). Andere Länder: ' + this.kontakt, 'fehler');
            if (/^(DE|ATU)/.test(roh)) return this.feld('ustid', 'Die Nummer passt nicht zum gewählten Land. Für ' + (at ? 'Österreich beginnt sie mit ATU.' : 'Deutschland beginnt sie mit DE.'), 'fehler');
            return this.feld('ustid', 'Aktuell für Betriebe aus Deutschland und Österreich. Andere Länder: ' + this.kontakt, 'fehler');
          }
          return this.feld('ustid', at ? 'ATU und 8 Ziffern, z. B. ATU12345678.' : 'DE und 9 Ziffern, z. B. DE123456789. Keine USt-IdNr.? Dann setz das Häkchen darunter.', 'fehler');
        }
        this.feld('ustid', '', '');
      }

      feld(name, text, art) {
        const hinweis = this.form.querySelector('[data-hinweis="' + name + '"]');
        const wrap = this.form.elements[name] && this.form.elements[name].closest('.custom-b2b-reg__feld');
        if (hinweis) {
          hinweis.textContent = text;
          hinweis.classList.remove('is-ok', 'is-fehler');
          if (art) hinweis.classList.add('is-' + art);
        }
        if (wrap) { wrap.classList.toggle('is-fehler', art === 'fehler'); wrap.classList.toggle('is-ok', art === 'ok'); }
      }

      icon(art) {
        const s = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
        if (art === 'ok') return '<svg viewBox="0 0 24 24" ' + s + '><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>';
        if (art === 'fehler') return '<svg viewBox="0 0 24 24" ' + s + '><path d="M12 3.5l9 16H3z"/><path d="M12 10v4M12 17h.01"/></svg>';
        return '<svg viewBox="0 0 24 24" ' + s + '><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>';
      }

      zeige(art, html) {
        this.status.hidden = false;
        this.status.className = 'custom-b2b-reg__status is-' + art;
        this.statusIcon.innerHTML = this.icon(art);
        this.statusText.innerHTML = html;
        this.status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      warten(an) {
        this.btn.disabled = an;
        this.btn.querySelector('.custom-b2b-reg__btn-text').hidden = an;
        this.btn.querySelector('.custom-b2b-reg__btn-wait').hidden = !an;
      }

      async senden(e) {
        e.preventDefault();
        const ohne = !!(this.ohne && this.ohne.checked);
        const fd = new FormData(this.form);
        fd.delete('dokument'); // Datei geht gleich als Base64 mit, nicht als FormData-Eintrag
        const daten = Object.fromEntries(fd.entries());
        daten.agb = this.form.elements.agb.checked;
        daten.newsletter = !!(this.form.elements.newsletter && this.form.elements.newsletter.checked);
        daten.ohne_ustid = ohne;
        this.status.hidden = true;

        // Pflichtfelder lokal prüfen, bevor der Dienst angefragt wird
        let erstesFehlerfeld = null;
        for (const el of this.form.querySelectorAll('input[required], select[required]')) {
          const leer = el.type === 'checkbox' ? !el.checked : !el.value.trim();
          if (leer) { this.feld(el.name, el.type === 'checkbox' ? 'Bitte bestätigen.' : el.tagName === 'SELECT' ? 'Bitte auswählen.' : 'Bitte ausfüllen.', 'fehler'); erstesFehlerfeld = erstesFehlerfeld || el; }
        }
        if (erstesFehlerfeld) { erstesFehlerfeld.focus(); return; }

        this.warten(true);
        try {
          if (ohne) {
            try {
              daten.dokument = await this.dokumentLesen(this.form.elements.dokument.files[0]);
            } catch (err) {
              this.feld('dokument', err.message || 'Datei konnte nicht gelesen werden.', 'fehler');
              this.form.elements.dokument.focus();
              return;
            }
          }
          const r = await fetch(this.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Presch-Form': this.dataset.secret || '' },
            body: JSON.stringify(daten),
          });
          const j = await r.json().catch(() => ({ status: 'fehler', text: 'Antwort nicht lesbar.' }));
          const login = this.dataset.login || '/account/login';
          // Nach dem Login zurück auf die Startseite statt auf die Kontoseite: Shopify übernimmt return_url als return_to,
          // der Kunde sieht sofort seine Gewerbepreise im Shop (Wunsch Mathias 09.10.). Ein automatischer Login ist in
          // Shopify nicht möglich, der Kunde gibt seine E-Mail ein und bekommt einen Code.
          // Vorher abmelden: Hängt im Browser noch eine andere Sitzung (Test 09.10.: altes Konto statt dem neuen),
          // würde der Login-Link dorthin führen. /account/logout reicht return_url durch (per curl geprüft).
          const loginUrl = login + (login.includes('?') ? '&' : '?') + 'return_url=' + encodeURIComponent(this.dataset.rueckkehr || '/');
          const loginZiel = '/account/logout?return_url=' + encodeURIComponent(loginUrl);

          if (j.status === 'ok') {
            this.form.classList.add('is-fertig');
            this.zeige('ok', '<strong>Geschafft.</strong> ' + this.esc(j.text) + ' Gleich geht es zum Login: E-Mail eingeben, Code aus der Mail eintippen, fertig.<br><a class="custom-b2b-reg__btn" href="' + loginZiel + '">Jetzt einloggen</a>');
            // Nach kurzer Lesezeit automatisch weiter; wer schneller ist, klickt den Button.
            setTimeout(() => { window.location.assign(loginZiel); }, 6000);
          } else if (j.status === 'pruefung') {
            this.form.classList.add('is-fertig');
            this.zeige('pruefung', '<strong>Fast geschafft.</strong> ' + this.esc(j.text));
          } else {
            if (j.feld) { this.feld(j.feld, j.text, 'fehler'); const el = this.form.elements[j.feld]; if (el) el.focus(); }
            this.zeige('fehler', this.esc(j.text || 'Da ist etwas schiefgelaufen.') + (j.login ? ' <a class="custom-b2b-reg__link" href="' + login + '">Zum Login</a>' : ''));
          }
        } catch (err) {
          this.zeige('fehler', 'Gerade keine Verbindung. Versuch es gleich noch einmal oder schreib uns an ' + this.esc(this.kontakt) + ' schreiben.');
        } finally {
          this.warten(false);
        }
      }

      ohneUmschalten() {
        const an = this.ohne.checked;
        const ust = this.form.elements.ustid;
        this.form.classList.toggle('is-ohne-ustid', an);
        ust.disabled = an;
        ust.required = !an;
        if (an) { ust.value = ''; this.feld('ustid', 'Brauchst du nicht, du lädst stattdessen deine Gewerbeanmeldung hoch.', ''); }
        else this.feld('ustid', this.ustHinweis(), '');
        this.nachweis.hidden = !an;
        this.nachweis.querySelectorAll('input').forEach((i) => { i.disabled = !an; i.required = an; });
        const wait = this.btn.querySelector('.custom-b2b-reg__btn-wait-text');
        if (wait) wait.textContent = an ? wait.dataset.textNachweis : wait.dataset.textVies;
        if (an) this.form.elements.dokument.focus();
      }

      // Datei lesen: Fotos im Browser auf 2000 px verkleinern (JPEG), PDF unverändert; Grenze 3 MB (Dienst und Vercel).
      async dokumentLesen(file) {
        if (!file) throw new Error('Bitte Gewerbeanmeldung oder Handwerkskarte auswählen.');
        const MAX = 3 * 1024 * 1024;
        const istBild = file.type.startsWith('image/') || /\.(heic|heif|jpe?g|png|webp)$/i.test(file.name);
        let blob = file;
        if (istBild) {
          // Kann der Browser das Bild nicht lesen (z. B. HEIC in Chrome), geht das Original mit; der Dienst nimmt HEIC an.
          try { blob = await this.bildVerkleinern(file); } catch (e) { blob = file; }
        }
        if (blob.size > MAX) throw new Error(istBild ? 'Das Foto ist zu groß, bitte als JPG oder PDF bis 3 MB.' : 'Die Datei ist zu groß, bitte höchstens 3 MB.');
        const inhalt = await new Promise((ok, nein) => {
          const r = new FileReader();
          r.onload = () => ok(String(r.result).split(',')[1] || '');
          r.onerror = () => nein(new Error('Datei konnte nicht gelesen werden, bitte noch einmal auswählen.'));
          r.readAsDataURL(blob);
        });
        const name = blob === file ? file.name : file.name.replace(/\.[^.]+$/, '') + '.jpg';
        return { name, inhalt };
      }

      async bildVerkleinern(file) {
        const bmp = await createImageBitmap(file);
        const faktor = Math.min(1, 2000 / Math.max(bmp.width, bmp.height));
        if (faktor === 1 && file.type === 'image/jpeg' && file.size <= 1.5 * 1024 * 1024) { bmp.close(); return file; }
        const c = document.createElement('canvas');
        c.width = Math.round(bmp.width * faktor);
        c.height = Math.round(bmp.height * faktor);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        bmp.close();
        const blob = await new Promise((ok) => c.toBlob(ok, 'image/jpeg', 0.85));
        if (!blob) throw new Error('Bild konnte nicht umgewandelt werden.');
        return blob;
      }

      esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
    }
    customElements.define('custom-b2b-reg', CustomB2bReg);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  // Mobil-Optimierung 2026-09-08: Die Familien-Pillen stehen auf dem Telefon in
  // einer wischbaren Zeile (CSS). Die AKTIVE Pille ist nicht immer die erste —
  // beim SPOTIX Set ist sie die zweite, bei einer 10m-Bandmass-Seite die
  // letzte. Liegt sie ausserhalb des Sichtfensters, sieht der Kunde nur fremde
  // Werte und nicht den eigenen. Deshalb einmal beim Aufbau die Zeile so
  // scrollen, dass die aktive Pille sichtbar ist — nur die Zeile selbst
  // (`inline`), die Seite bleibt, wo sie ist (`block: 'nearest'`).
  document.querySelectorAll('.custom-pdp-hero__varianten-liste').forEach((liste) => {
    if (liste.scrollWidth <= liste.clientWidth) return;
    const aktiv = liste.querySelector('.custom-pdp-hero__variante--aktiv');
    if (!aktiv) return;
    const rand = liste.getBoundingClientRect();
    const pille = aktiv.getBoundingClientRect();
    if (pille.left >= rand.left && pille.right <= rand.right) return;
    liste.scrollLeft = aktiv.offsetLeft - liste.offsetLeft - 24;
  });

  // Shopifys AR-Ansicht freischalten.
  //
  // Horizon tut das in `product-media-gallery-content.liquid` — dem Baustein,
  // den diese Vorlage nicht benutzt. Ohne diesen Aufruf bleibt
  // `window.ShopifyXR` undefiniert, `setupXRElements()` laeuft nie, und der
  // Knopf traegt bis in alle Ewigkeit `data-shopify-xr-hidden`. Gemessen:
  // ShopifyXR undefined, kein XR-Skript auf der Seite, Knopf unsichtbar — auch
  // auf dem Telefon.
  //
  // `addModels` liest die Modelldaten aus den ProductModelJSON-Skripten und
  // entfernt sie danach, genau wie Horizons eigene Fassung.
  const preschXrStart = () => {
    if (!document.querySelector('[id^="ProductModelJSON-"]')) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    if (window.PreschXR) return;
    window.PreschXR = {
      laden() {
        window.Shopify.loadFeatures([
          { name: 'shopify-xr', version: '1.0', onLoad: this.einrichten.bind(this) },
        ]);
      },
      einrichten(fehler) {
        if (fehler) return;
        if (!window.ShopifyXR) {
          document.addEventListener('shopify_xr_initialized', () => this.einrichten(), { once: true });
          return;
        }
        document.querySelectorAll('[id^="ProductModelJSON-"]').forEach((el) => {
          try {
            window.ShopifyXR.addModels(JSON.parse(el.textContent));
            el.remove();
          } catch (e) {
            /* Fehlerhaftes JSON darf die Galerie nicht mitnehmen. */
          }
        });
        window.ShopifyXR.setupXRElements();
      },
    };
    window.PreschXR.laden();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preschXrStart, { once: true });
  } else {
    preschXrStart();
  }

  // Nach der Rueckkehr aus „In deinem Raum ansehen" (AR Quick Look) blieb die
  // Seite auf iOS scheinbar haengen: Man konnte nicht mehr ganz nach oben
  // scrollen (Kollegen-Video 2026-08-28). Ursache ist ein Deadlock in Horizons
  // Header-Zustandsmaschine (assets/header.js): Quick Look stellt die
  // Scrollposition beim Schliessen SPRUNGHAFT wieder her. Meldet der
  // IntersectionObserver den Header dabei als sichtbar, bevor der (per rAF
  // gedrosselte) Scroll-Handler laeuft, steigt `#updateScrollState` fortan
  // frueh aus (`!offscreen`) — der Header bleibt in `data-sticky-state="idle"`
  // (opacity: 0) und belegt oben unsichtbar seine Hoehe. Fuer den Nutzer sieht
  // das aus, als fehle das Seitenende nach oben.
  //
  // Reparatur ohne Vendor-Eingriff: Nach jedem AR-Start wird bei der Rueckkehr
  // (visibilitychange -> visible) der Header-Zustand geprueft und, falls er
  // unsichtbar im Sichtfeld haengt, auf den natuerlichen Zustand zurueckgesetzt.
  // Der Mini-Scroll-Anstoss danach laesst Horizons eigene Logik und iOS'
  // Compositing neu rechnen — unschaedlich, wenn gar nichts klemmte.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-shopify-xr]')) return;
    const beiRueckkehr = () => {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', beiRueckkehr);
      setTimeout(() => {
        const header = document.querySelector('header-component');
        if (header instanceof HTMLElement && header.dataset.stickyState === 'idle') {
          const lage = header.getBoundingClientRect();
          if (lage.bottom > 0 && lage.top < window.innerHeight) {
            header.dataset.stickyState = 'inactive';
            header.dataset.scrollDirection = 'none';
          }
        }
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
      }, 250);
    };
    document.addEventListener('visibilitychange', beiRueckkehr);
    // Falls Quick Look gar nicht oeffnet (z. B. Abbruch), Aufraeumer nach 60 s.
    setTimeout(() => document.removeEventListener('visibilitychange', beiRueckkehr), 60000);
  });

  if (!customElements.get('custom-pdp-gallery')) {
    customElements.define(
      'custom-pdp-gallery',
      class extends HTMLElement {
        connectedCallback() {
          // Ein <img> je Bild-Medium; this.main zeigt stets auf das gerade
          // sichtbare. Grund fuer den Umbau: siehe Kommentar am Markup
          // (Bild-Uebersetzungs-App ueberschrieb src-Tausch auf FR/NL).
          this.bilder = [...this.querySelectorAll('.custom-pdp-hero__bild')];
          this.main = this.querySelector('[data-ref="mainImage"]') || this.bilder[0];
          this.stage = this.querySelector('[data-ref="stage"]');
          this.model = this.querySelector('product-model');

          // Hover aktiviert das 3D-Modell und laesst es sanft rotieren; beim
          // Verlassen stoppt die Drehung. Nur auf echten Hover-Geraeten —
          // Touch laedt weiter per Tap (Horizon-Standardverhalten).
          if (this.model && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.stage.addEventListener('mouseenter', () => {
              if (this.stage.dataset.mode !== 'model') return;
              this.activateModel();
              requestAnimationFrame(() => this.setRotate(true));
            });
            this.stage.addEventListener('mouseleave', () => this.setRotate(false));
          }

          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('.custom-pdp-hero__thumb');
            if (!thumb || !this.main) return;
            if (thumb.dataset.type === 'model') {
              this.stage.dataset.mode = 'model';
              // Direkt laden, statt ein Poster mit Abspielzeichen zu zeigen.
              //
              // Shopify liefert 3D-Medien als „deferred media": Das Markup
              // enthaelt nur ein Vorschaubild, der model-viewer steckt in einem
              // <template> und wird erst auf Klick eingesetzt. Grund ist das
              // Gewicht — die GLB dieses Produkts ist gemessen 1,81 MB, dazu
              // kommt die Viewer-Bibliothek.
              //
              // Wer aber die 3D-Miniatur antippt oder mit den Pfeilen dorthin
              // blaettert, hat das Modell schon angefordert. Ein zweiter Tipp
              // auf ein Bild, das aussieht wie das Standardfoto, ist dann kein
              // Schutz vor Datenverbrauch, sondern eine Sackgasse.
              //
              // Beim Seitenaufbau laedt weiterhin NICHTS: Die Aktivierung
              // haengt allein an dieser bewussten Auswahl.
              this.activateModel();
              this.stopVideos();
            } else if (thumb.dataset.type === 'video') {
              this.stage.dataset.mode = 'video';
              // Der Klick auf die Miniatur IST die Abspielabsicht — die
              // Nutzergeste erlaubt play() mit Ton, ein zweiter Klick auf den
              // Play-Knopf im Video waere nur ein Umweg.
              this.zeigeVideo(thumb.dataset.mediaId);
            } else {
              this.stage.dataset.mode = 'image';
              this.stopVideos();
              // Harter Schnitt, keine Animation (Design-Vorgabe):
              // Sichtbarkeit umschalten statt src-Tausch (App-Kollision,
              // siehe Markup-Kommentar an den Buehnenbildern).
              this.zeigeBild(thumb.dataset.mediaId);
            }
            this.querySelectorAll('.custom-pdp-hero__thumb[aria-current]').forEach((el) =>
              el.removeAttribute('aria-current')
            );
            thumb.setAttribute('aria-current', 'true');
            const stelle = this.bildThumbs.indexOf(thumb);
            if (stelle > -1) this.index = stelle;
            // Leiste mitziehen (Wunsch 2026-08-28): Wer die letzte sichtbare
            // Kachel antippt, schiebt die Reihe damit weiter — `inline:
            // 'center'` rueckt den gewaehlten Thumb zur Mitte (am Rand
            // geklemmt), das sind vom fuenften Platz aus zwei Positionen.
            // `block: 'nearest'` verhindert, dass die SEITE mitscrollt.
            // Gilt auch fuer die Buehnen-Pfeile, die diesen Klickpfad nutzen.
            const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            thumb.scrollIntoView({
              behavior: ruhig ? 'instant' : 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          });

          // Blaettern: Wischen und Pfeile. Die Liste sind ALLE Miniaturen in
          // ihrer Reihenfolge, das 3D-Modell eingeschlossen — vorher filterte
          // `[data-image]` es heraus und das Blaettern uebersprang es.
          this.bildThumbs = [...this.querySelectorAll('.custom-pdp-hero__thumb')];
          this.index = Math.max(
            0,
            this.bildThumbs.findIndex((t) => t.hasAttribute('aria-current'))
          );
          if (this.bildThumbs.length > 1) this.blaetternEinrichten();
        }

        zeigeIndex(i) {
          const n = this.bildThumbs.length;
          if (!n) return;
          const ziel = ((i % n) + n) % n;
          const thumb = this.bildThumbs[ziel];
          // Ueber den vorhandenen Klickpfad, damit src, srcset, alt,
          // aria-current, Bildmodus UND das Nachziehen der Thumb-Leiste an
          // genau einer Stelle passieren (das Zentrieren sitzt im Handler).
          thumb.click();
        }

        // Fluessiger Bildwechsel nach einem Wisch: Das aktuelle Bild gleitet in
        // Wischrichtung hinaus, das naechste von der Gegenseite herein. Die
        // Buehne clippt per overflow:hidden.
        //
        // Der Wisch blaettert durch Bilder UND Videos in Medien-Reihenfolge
        // (Wunsch 2026-08-31: nichts ueberspringen) — nur das 3D-Modell wird
        // ausgelassen: Im Modell-Modus gehoert die Wischgeste dem Drehen des
        // Modells, wer per Swipe hineinrutschte, kaeme per Swipe nie wieder
        // heraus (die Falle aus Hergens Meldung vom 2026-08-30). Das Modell
        // erreichen Kunden gezielt ueber Miniatur und Pfeile; die Pfeile
        // blaettern unveraendert durch ALLE Medien.
        wischWechsel(richtung) {
          const n = this.bildThumbs.length;
          if (!n) return;
          // Naechsten Thumb in Wischrichtung suchen (mit Umlauf), 3D auslassen.
          let thumb = null;
          for (let schritt = 1; schritt <= n; schritt += 1) {
            const kandidat = this.bildThumbs[(((this.index + richtung * schritt) % n) + n) % n];
            const typ = kandidat.dataset.type || 'image';
            if (typ !== 'model') {
              thumb = kandidat;
              break;
            }
          }
          if (!thumb) {
            this.main.style.transition = 'none';
            this.main.style.transform = '';
            return;
          }
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (ruhig || this.stage.dataset.mode !== 'image' || thumb.dataset.type === 'video') {
            // Kein Gleiten: bei reduzierter Bewegung, wenn gerade das Video
            // laeuft (das Hauptbild ist dann unsichtbar — eine Animation
            // daran waere Theater ohne Publikum) oder wenn das ZIEL ein Video
            // ist (der Buehnenmodus wechselt, Bild-Transforms greifen nicht).
            this.main.style.transition = 'none';
            this.main.style.transform = '';
            thumb.click();
            return;
          }
          const altesBild = this.main;
          const breite = this.stage.clientWidth || 320;
          let fertig = false;
          const weiter = () => {
            if (fertig) return;
            fertig = true;
            altesBild.removeEventListener('transitionend', weiter);
            // Wechsel ueber den Klickpfad (Sichtbarkeit, aria-current,
            // Thumb-Leiste) — danach zeigt this.main auf das NEUE Bild, das
            // von der Gegenseite hereingleitet.
            thumb.click();
            altesBild.style.transition = 'none';
            altesBild.style.transform = '';
            const neues = this.main;
            if (neues === altesBild) return;
            neues.style.transition = 'none';
            neues.style.transform = 'translateX(' + richtung * breite + 'px)';
            requestAnimationFrame(() =>
              requestAnimationFrame(() => {
                neues.style.transition = 'transform 200ms cubic-bezier(0.2, 0, 0.1, 1)';
                neues.style.transform = '';
              })
            );
          };
          altesBild.addEventListener('transitionend', weiter);
          // Sicherheitsnetz: transitionend bleibt aus, wenn der Tab wechselt
          // oder Safari den Uebergang verschluckt — dann trotzdem tauschen.
          setTimeout(weiter, 220);
          altesBild.style.transition = 'transform 140ms ease-out';
          altesBild.style.transform = 'translateX(' + -richtung * breite + 'px)';
        }

        blaetternEinrichten() {
          const buehne = this.stage;
          let x0 = null;
          let y0 = null;
          let dx = 0;
          let ziehen = false;

          buehne.addEventListener(
            'touchstart',
            (e) => {
              // Wischen ist im Bild- UND im Video-Modus erlaubt. Vorher galt
              // nur 'image' — wer per Swipe auf dem Video landete, sass fest:
              // jeder weitere Wisch prallte am Guard ab, das Bild schnappte
              // zurueck und es sah aus, als kaeme "immer wieder das Main
              // Image" (Hergen, 2026-08-30). Nur der 3D-Modus blockiert
              // weiter: Dort dreht die Geste das Modell (bewusste
              // Entscheidung), heraus kommt man ueber die Miniaturen.
              if (buehne.dataset.mode === 'model' || e.touches.length !== 1) return;
              x0 = e.touches[0].clientX;
              y0 = e.touches[0].clientY;
              dx = 0;
              ziehen = false;
            },
            { passive: true }
          );

          buehne.addEventListener(
            'touchmove',
            (e) => {
              if (x0 === null) return;
              const ax = e.touches[0].clientX - x0;
              const ay = e.touches[0].clientY - y0;
              // Erst ab 8px entscheiden, ob die Geste waagerecht gemeint ist —
              // sonst kapert die Galerie jedes Scrollen, das leicht schraeg
              // beginnt.
              if (!ziehen && Math.abs(ax) > Math.abs(ay) && Math.abs(ax) > 8) ziehen = true;
              if (!ziehen) return;
              // Das Bild folgt dem Finger 1:1 — die alte 140px-Deckelung liess
              // die Geste abrupt „gegen eine Wand" laufen und fuehlte sich wie
              // ein Springen an (Kollegen-Feedback 2026-08-28).
              dx = ax;
              this.main.style.transition = 'none';
              this.main.style.transform = 'translateX(' + dx + 'px)';
            },
            { passive: true }
          );

          const ende = () => {
            if (x0 === null) return;
            if (ziehen && Math.abs(dx) > 40) {
              // Wisch abgeschlossen: fluessig weitergleiten statt zurueck-
              // schnappen und hart tauschen. Der harte Schnitt bleibt bewusst
              // nur beim KLICK auf eine Miniatur (Design-Vorgabe) — beim
              // Wischen erwartet der Daumen die Bewegung, die er angefangen hat
              // (Kollegen-Feedback 2026-08-28: „springt, fuehlt sich nicht gut an").
              this.wischWechsel(dx < 0 ? 1 : -1);
            } else {
              this.main.style.transition = 'transform 180ms cubic-bezier(0.2, 0, 0.1, 1)';
              this.main.style.transform = '';
            }
            x0 = null;
            y0 = null;
            dx = 0;
            ziehen = false;
          };

          buehne.addEventListener('touchend', ende, { passive: true });
          buehne.addEventListener('touchcancel', ende, { passive: true });

          this.querySelectorAll('[data-gallery-pfeil]').forEach((knopf) => {
            knopf.addEventListener('click', (e) => {
              e.preventDefault();
              this.zeigeIndex(this.index + (knopf.dataset.galleryPfeil === 'vor' ? 1 : -1));
            });
          });
        }

        zeigeBild(mediaId) {
          let ziel = this.bilder.find((b) => b.dataset.mediaId === mediaId);
          if (!ziel) ziel = this.bilder[0];
          if (!ziel) return;
          this.bilder.forEach((b) => {
            if (b !== ziel) b.hidden = true;
          });
          ziel.hidden = false;
          this.main = ziel;
        }

        zeigeVideo(mediaId) {
          this.querySelectorAll('.custom-pdp-hero__videowrap').forEach((wrap) => {
            const aktiv = wrap.dataset.videoId === mediaId;
            if (!aktiv) this.stoppeVideo(wrap);
            wrap.hidden = !aktiv;
            if (aktiv) {
              const video = wrap.querySelector('video');
              if (video) video.play().catch(() => {});
            }
          });
        }

        stopVideos() {
          this.querySelectorAll('.custom-pdp-hero__videowrap').forEach((wrap) => {
            this.stoppeVideo(wrap);
            wrap.hidden = true;
          });
        }

        stoppeVideo(wrap) {
          const video = wrap.querySelector('video');
          if (video && !video.paused) video.pause();
          // YouTube/Vimeo laufen in einem versteckten iframe weiter — das
          // Neusetzen der src laedt den Player neu und stoppt damit den Ton.
          const frame = wrap.querySelector('iframe');
          if (frame && frame.src) frame.src = frame.src; // eslint-disable-line no-self-assign
        }

        activateModel() {
          if (this.modelActivated || !this.model) return;
          this.modelActivated = true;
          if (typeof this.model.showDeferredMedia === 'function') {
            this.model.showDeferredMedia();
          }
        }

        setRotate(on) {
          const viewer = this.model && this.model.querySelector('model-viewer');
          if (!viewer) return;
          if (on) {
            viewer.setAttribute('auto-rotate', '');
            viewer.setAttribute('rotation-per-second', '25deg');
          } else {
            viewer.removeAttribute('auto-rotate');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scroll-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function map(v, a, b, c, d) {
    return c + (d - c) * clamp((v - a) / (b - a), 0, 1);
  }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  // ---------- Demo-Renderer (läuft nur ohne Video-URL) ----------
  function createDemoRenderer(canvas) {
    var ctx = canvas.getContext('2d');
    var ORANGE = '#eb6012';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;
    var R = 26;
    // Hintergrund und Vignette sind statisch pro Groesse: einmal in
    // Offscreen-Canvases rendern statt pro Frame (Radial-Gradients sind teuer)
    var bgCanvas = document.createElement('canvas');
    var vgCanvas = document.createElement('canvas');

    function renderStatic() {
      bgCanvas.width = W * dpr;
      bgCanvas.height = H * dpr;
      var bctx = bgCanvas.getContext('2d');
      bctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var bg = bctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, Math.max(W, H) * 0.75);
      bg.addColorStop(0, '#22384a');
      bg.addColorStop(1, '#101c26');
      bctx.fillStyle = bg;
      bctx.fillRect(0, 0, W, H);
      bctx.strokeStyle = 'rgba(255,255,255,0.03)';
      bctx.lineWidth = 1;
      for (var gx = 0; gx < W; gx += 60) {
        bctx.beginPath(); bctx.moveTo(gx, 0); bctx.lineTo(gx, H); bctx.stroke();
      }
      for (var gy = 0; gy < H; gy += 60) {
        bctx.beginPath(); bctx.moveTo(0, gy); bctx.lineTo(W, gy); bctx.stroke();
      }

      vgCanvas.width = W * dpr;
      vgCanvas.height = H * dpr;
      var vctx = vgCanvas.getContext('2d');
      vctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var vg = vctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.4, W / 2, H / 2, Math.max(W, H) * 0.8);
      vg.addColorStop(0, 'rgba(0,0,0,0)');
      vg.addColorStop(1, 'rgba(0,0,0,0.45)');
      vctx.fillStyle = vg;
      vctx.fillRect(0, 0, W, H);
    }

    function resize() {
      W = canvas.clientWidth;
      H = canvas.clientHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      renderStatic();
    }
    window.addEventListener('resize', resize);
    resize();

    function rr(x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }
    function shade(hex, amt) {
      var n = parseInt(hex.slice(1), 16);
      var r = clamp((n >> 16) + amt, 0, 255);
      var g = clamp(((n >> 8) & 0xff) + amt, 0, 255);
      var b = clamp((n & 0xff) + amt, 0, 255);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
    function metal(base, y, h, lightPos) {
      var g = ctx.createLinearGradient(0, y, 0, y + h);
      g.addColorStop(0, shade(base, -35));
      g.addColorStop(clamp(lightPos, 0.05, 0.95), shade(base, 45));
      g.addColorStop(1, shade(base, -45));
      return g;
    }

    function drawBody(light) {
      ctx.fillStyle = metal('#3a4d61', -R, 2 * R, light);
      rr(-280, -R, 340, 2 * R, 10);
      ctx.fill();
      ctx.fillStyle = ORANGE;
      ctx.fillRect(-70, -R, 14, 2 * R);
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.font = '700 20px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('PRESCH', -160, 1);
      ctx.fillStyle = metal('#2c3b4a', -R + 4, 2 * R - 8, light);
      rr(-302, -R + 4, 24, 2 * R - 8, 8);
      ctx.fill();
    }
    function drawGrip(light) {
      ctx.fillStyle = metal('#31424f', -R, 2 * R, light);
      rr(60, -R, 120, 2 * R, 6);
      ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,0.35)';
      ctx.lineWidth = 1.5;
      for (var i = 0; i < 10; i++) {
        var x = 70 + i * 11;
        ctx.beginPath();
        ctx.moveTo(x, -R + 3);
        ctx.lineTo(x, R - 3);
        ctx.stroke();
      }
    }
    function drawCone(light) {
      var g = ctx.createLinearGradient(0, -R, 0, R);
      g.addColorStop(0, shade('#46586b', -30));
      g.addColorStop(clamp(light, 0.05, 0.95), shade('#46586b', 55));
      g.addColorStop(1, shade('#46586b', -40));
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(180, -R);
      ctx.lineTo(250, -6);
      ctx.lineTo(250, 6);
      ctx.lineTo(180, R);
      ctx.closePath();
      ctx.fill();
    }
    function drawNeedle() {
      var g = ctx.createLinearGradient(0, -3, 0, 3);
      g.addColorStop(0, '#9fb2c4');
      g.addColorStop(0.5, '#e8eef4');
      g.addColorStop(1, '#7d90a2');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(250, -4);
      ctx.lineTo(328, -1);
      ctx.lineTo(332, 0);
      ctx.lineTo(328, 1);
      ctx.lineTo(250, 4);
      ctx.closePath();
      ctx.fill();
    }
    function drawClip(light) {
      ctx.fillStyle = metal('#22303c', -R - 12, 10, light);
      rr(-278, -R - 12, 150, 10, 5);
      ctx.fill();
      rr(-286, -R - 12, 14, 22, 5);
      ctx.fill();
    }

    return function draw(p) {
      ctx.drawImage(bgCanvas, 0, 0, W, H);

      var asm = easeOut(map(p, 0.02, 0.33, 0, 1));
      var rot = easeInOut(map(p, 0.35, 0.65, 0, 1));
      var zoom = easeInOut(map(p, 0.65, 0.98, 0, 1));
      var light = clamp(0.5 + 0.45 * Math.sin(p * 6), 0.05, 0.95);

      var baseScale = Math.min(W / 900, H / 600);
      var scale = baseScale * (1 + zoom * 3.2);
      var angle = -0.35 + asm * 0.25 + rot * 0.45 - zoom * 0.32;
      var cx = W / 2 - zoom * 300 * scale * Math.cos(angle);
      var cy = H / 2 - zoom * 300 * scale * Math.sin(angle) - H * 0.02;

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(angle);
      ctx.scale(scale, scale);

      ctx.save();
      ctx.rotate(-angle);
      ctx.fillStyle = 'rgba(0,0,0,0.35)';
      ctx.beginPath();
      ctx.ellipse(0, 130 / (1 + zoom * 2), 320 * (1 - zoom * 0.5), 26, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();

      var off = 1 - asm;

      ctx.save();
      ctx.translate(-420 * off, 0);
      ctx.globalAlpha = clamp(asm * 2.2, 0, 1);
      drawBody(light);
      ctx.restore();

      ctx.save();
      ctx.translate(-120 * off, -260 * off);
      ctx.globalAlpha = clamp(asm * 2.2 - 0.15, 0, 1);
      drawClip(light);
      ctx.restore();

      ctx.save();
      ctx.translate(60 * off, 300 * off);
      ctx.globalAlpha = clamp(asm * 2.2 - 0.3, 0, 1);
      drawGrip(light);
      ctx.restore();

      ctx.save();
      ctx.translate(300 * off, -80 * off);
      ctx.globalAlpha = clamp(asm * 2.2 - 0.45, 0, 1);
      drawCone(light);
      ctx.restore();

      ctx.save();
      ctx.translate(480 * off, 40 * off);
      ctx.globalAlpha = clamp(asm * 2.2 - 0.6, 0, 1);
      drawNeedle();
      ctx.restore();

      if (zoom > 0.25) {
        var m = map(zoom, 0.25, 1, 0, 1);
        ctx.globalAlpha = m;
        ctx.fillStyle = ORANGE;
        ctx.beginPath();
        ctx.arc(332, 0, 3 + m * 3, 0, Math.PI * 2);
        ctx.fill();
        var glow = ctx.createRadialGradient(332, 0, 0, 332, 0, 40);
        glow.addColorStop(0, 'rgba(235,96,18,0.5)');
        glow.addColorStop(1, 'rgba(235,96,18,0)');
        ctx.fillStyle = glow;
        ctx.beginPath();
        ctx.arc(332, 0, 40, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,0.5)';
        ctx.lineWidth = 0.8;
        ctx.beginPath();
        ctx.moveTo(250, -22); ctx.lineTo(332, -22);
        ctx.moveTo(250, -26); ctx.lineTo(250, -18);
        ctx.moveTo(332, -26); ctx.lineTo(332, -18);
        ctx.stroke();
        ctx.fillStyle = 'rgba(255,255,255,0.85)';
        ctx.font = '600 9px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('80 mm Nadel', 291, -30);
        ctx.globalAlpha = 1;
      }

      ctx.restore();

      ctx.drawImage(vgCanvas, 0, 0, W, H);
    };
  }

  // ---------- Section-Setup ----------
  function initSection(section) {
    // Idempotent: der Theme-Editor ersetzt die Section-DOM bei jeder
    // Einstellungsaenderung, initSection laeuft dann erneut fuer die neue DOM
    if (section.dataset.svInit) return;
    section.dataset.svInit = '1';

    var stage = section.querySelector('.scroll-video-section__stage');
    var video = section.querySelector('.scroll-video-section__video');
    var canvas = section.querySelector('.scroll-video-section__canvas');
    var progress = section.querySelector('.scroll-video-section__progress');
    var captions = Array.prototype.slice.call(
      section.querySelectorAll('.scroll-video-section__caption')
    );

    var demoDraw = canvas ? createDemoRenderer(canvas) : null;
    var duration = 0;
    var targetP = 0;
    var currentP = 0;
    var raf = null;
    var active = false;
    var seekBusy = false;
    var seekAgain = -1;

    function getProgress() {
      var rect = section.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) return 0;
      return clamp(-rect.top / total, 0, 1);
    }

    function updateCaptions(p) {
      captions.forEach(function (el) {
        var s = parseFloat(el.dataset.start);
        var e = parseFloat(el.dataset.end);
        var fade = 0.05;
        var o = 0;
        if (p > s && p < e) {
          o = Math.min(map(p, s, s + fade, 0, 1), map(p, e - fade, e, 1, 0));
        }
        el.style.opacity = o.toFixed(3);
      });
    }

    // Seek-Guard: erst wieder seeken, wenn der Browser den vorherigen Seek
    // abgeschlossen hat ('seeked'). Ohne das stauen sich Seeks und das Video
    // haengt sichtbar, besonders bei Videos ohne dichte Keyframes.
    function seekTo(t) {
      if (seekBusy) {
        seekAgain = t;
        return;
      }
      seekBusy = true;
      if (typeof video.fastSeek === 'function') {
        video.fastSeek(t);
      } else {
        video.currentTime = t;
      }
    }

    function render(p) {
      if (demoDraw) {
        demoDraw(p);
      } else if (duration > 0) {
        seekTo(p * duration);
      }
    }

    function tick() {
      raf = null;
      currentP += (targetP - currentP) * 0.18;
      if (Math.abs(targetP - currentP) < 0.0005) currentP = targetP;
      render(currentP);
      updateCaptions(currentP);
      if (progress) progress.style.width = (currentP * 100).toFixed(2) + '%';
      if (currentP !== targetP) raf = requestAnimationFrame(tick);
    }

    function onScroll() {
      if (!active || !section.isConnected) return;
      targetP = getProgress();
      if (!raf) raf = requestAnimationFrame(tick);
    }

    if (video) {
      video.addEventListener('seeked', function () {
        seekBusy = false;
        if (seekAgain >= 0) {
          var t = seekAgain;
          seekAgain = -1;
          seekTo(t);
        }
      });
      video.addEventListener('loadedmetadata', function () {
        duration = video.duration;
        // iOS: Video muss einmal kurz "angestoßen" werden, damit Seeking geht
        video.play().then(function () { video.pause(); }).catch(function () {});
        onScroll();
      });
      if (video.readyState >= 1) {
        duration = video.duration;
      }
    }

    // Nur rechnen, wenn die Section im/nahe am Viewport ist
    var observer = new IntersectionObserver(
      function (entries) {
        active = entries[0].isIntersecting;
        if (active) onScroll();
      },
      { rootMargin: '50% 0px' }
    );
    observer.observe(stage);

    // Capture-Listener auf document statt window: Horizon scrollt auf Desktop
    // nicht das Fenster, sondern .page-wrapper (overflow-y: auto). Scroll-Events
    // bubbeln nicht, in der Capture-Phase kommen sie trotzdem hier an --
    // egal welcher Container tatsaechlich scrollt.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    if (demoDraw) demoDraw(0);
    onScroll();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.scroll-video-section').forEach(initSection);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  // Theme-Editor: Section wird bei Einstellungsaenderungen neu gerendert
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-set-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-set-galerie')) {
    customElements.define(
      'custom-set-galerie',
      class extends HTMLElement {
        connectedCallback() {
          this.bilder = Array.from(this.querySelectorAll('[data-galerie-bild]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-galerie-thumb]'));
          this.addEventListener('click', (e) => {
            const thumb = e.target.closest('[data-galerie-thumb]');
            if (!thumb) return;
            this.zeige(thumb.getAttribute('data-galerie-thumb'));
          });
        }

        zeige(nummer) {
          this.bilder.forEach((bild) => {
            const aktiv = bild.getAttribute('data-galerie-bild') === nummer;
            bild.toggleAttribute('hidden', !aktiv);
            if (aktiv) bild.removeAttribute('loading');
          });
          this.thumbs.forEach((thumb) => {
            thumb.setAttribute('aria-pressed', thumb.getAttribute('data-galerie-thumb') === nummer ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-set-leiste"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-set-leiste')) {
    customElements.define(
      'custom-set-leiste',
      class extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('[data-ziel]'));
          this.panels = [];
          this.links.forEach((link) => {
            const panel = document.getElementById(link.getAttribute('data-ziel'));
            if (panel && !this.panels.includes(panel)) this.panels.push(panel);
          });
          if (this.getAttribute('data-modus') === 'tabs' && this.panels.length > 1) {
            this.tabsStarten();
          } else {
            this.ankerStarten();
          }
          document.documentElement.classList.remove('custom-set-tabs-vorab');
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.hashHandler) window.removeEventListener('hashchange', this.hashHandler);
          if (this.onTouchStart) {
            document.removeEventListener('touchstart', this.onTouchStart);
            document.removeEventListener('touchend', this.onTouchEnd);
            document.removeEventListener('wheel', this.onWheel);
          }
        }

        tabsStarten() {
          const nav = this.querySelector('nav');
          if (nav) nav.setAttribute('role', 'tablist');
          this.links.forEach((link) => {
            const id = link.getAttribute('data-ziel');
            const panel = document.getElementById(id);
            if (!panel) return;
            if (!link.id) link.id = 'set-tab-' + id;
            link.setAttribute('role', 'tab');
            link.setAttribute('aria-controls', id);
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', link.id);
            panel.setAttribute('data-set-panel', '');
          });
          this.weiterLinksAnlegen();

          const ausHash = location.hash.replace('#', '');
          const start = this.panels.find((p) => p.id === ausHash) || this.panels[0];
          this.aktiv = start.id;
          this.zeige(start.id, ausHash === start.id ? 'immer' : 'nie');

          this.addEventListener('click', (e) => {
            const link = e.target.closest('[data-ziel]');
            if (!link) return;
            e.preventDefault();
            const id = link.getAttribute('data-ziel');
            this.wechsel(id, 'wenn-haftend');
            history.replaceState(null, '', '#' + id);
          });

          // Pfeiltasten zwischen den Reitern (WAI-ARIA Tabs).
          this.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const i = this.links.indexOf(document.activeElement);
            if (i < 0) return;
            e.preventDefault();
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.links.length) % this.links.length;
            this.links[n].focus();
            this.links[n].click();
          });

          // Links von anderswo (Bewertungszeile im Kaufbereich, Weiter-Link, geteilte Adresse).
          this.hashHandler = () => {
            const id = location.hash.replace('#', '');
            if (this.panels.some((p) => p.id === id)) this.wechsel(id, 'immer');
          };
          window.addEventListener('hashchange', this.hashHandler);

          // Wischen auf einem Abschnitt: deutlich waagerecht, mindestens 60px, zuegig.
          this.touchStart = null;
          this.onTouchStart = (e) => {
            if (!e.target.closest || !e.target.closest('[data-set-panel]')) {
              this.touchStart = null;
              return;
            }
            const t = e.changedTouches[0];
            this.touchStart = { x: t.clientX, y: t.clientY, zeit: Date.now() };
          };
          this.onTouchEnd = (e) => {
            const start = this.touchStart;
            this.touchStart = null;
            if (!start) return;
            const t = e.changedTouches[0];
            const dx = t.clientX - start.x;
            const dy = t.clientY - start.y;
            if (Date.now() - start.zeit > 800) return;
            if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            this.blaettern(dx < 0 ? 1 : -1);
          };
          document.addEventListener('touchstart', this.onTouchStart, { passive: true });
          document.addEventListener('touchend', this.onTouchEnd, { passive: true });

          // Waagerechtes Trackpad-Scrollen: nur deltaX, das Scrollrad nach unten bleibt unberuehrt.
          this.radSumme = 0;
          this.radSperre = 0;
          this.onWheel = (e) => {
            if (!e.target.closest || !e.target.closest('[data-set-panel]')) return;
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) * 2) {
              this.radSumme = 0;
              return;
            }
            const jetzt = Date.now();
            if (jetzt < this.radSperre) return;
            this.radSumme += e.deltaX;
            if (Math.abs(this.radSumme) < 120) return;
            const richtung = this.radSumme > 0 ? 1 : -1;
            this.radSumme = 0;
            this.radSperre = jetzt + 900;
            this.blaettern(richtung);
          };
          document.addEventListener('wheel', this.onWheel, { passive: true });
        }

        weiterLinksAnlegen() {
          const label = this.getAttribute('data-weiter-label') || 'Weiter';
          this.panels.forEach((panel, i) => {
            const naechstes = this.panels[i + 1];
            if (!naechstes) return;
            const link = this.links.find((l) => l.getAttribute('data-ziel') === naechstes.id);
            if (!link) return;
            const p = document.createElement('p');
            p.className = 'custom-set-leiste__weiter';
            const a = document.createElement('a');
            a.href = '#' + naechstes.id;
            a.textContent = label + ': ' + link.textContent.trim() + ' →';
            p.appendChild(a);
            panel.appendChild(p);
          });
        }

        blaettern(schritt) {
          const i = this.panels.findIndex((p) => p.id === this.aktiv);
          const n = i + schritt;
          if (i < 0 || n < 0 || n >= this.panels.length) return;
          const id = this.panels[n].id;
          this.wechsel(id, 'wenn-haftend');
          history.replaceState(null, '', '#' + id);
        }

        wechsel(id, scrollen) {
          const alt = document.getElementById(this.aktiv);
          const neu = document.getElementById(id);
          if (!neu) return;
          if (id === this.aktiv) {
            if (scrollen === 'immer') neu.scrollIntoView({ block: 'start' });
            return;
          }
          const klassen = ['custom-set-panel--raus-links', 'custom-set-panel--raus-rechts', 'custom-set-panel--rein-rechts', 'custom-set-panel--rein-links'];
          clearTimeout(this.timer);
          this.panels.forEach((p) => p.classList.remove(...klassen));
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (ruhig || !alt) {
            this.zeige(id, scrollen);
            return;
          }
          const vor = this.panels.indexOf(neu) > this.panels.indexOf(alt);
          alt.classList.add(vor ? 'custom-set-panel--raus-links' : 'custom-set-panel--raus-rechts');
          this.timer = setTimeout(() => {
            alt.classList.remove(...klassen);
            this.zeige(id, scrollen);
            neu.classList.add(vor ? 'custom-set-panel--rein-rechts' : 'custom-set-panel--rein-links');
            neu.addEventListener('animationend', () => neu.classList.remove(...klassen), { once: true });
          }, 160);
        }

        zeige(id, scrollen) {
          this.aktiv = id;
          this.panels.forEach((p) => p.toggleAttribute('hidden', p.id !== id));
          this.links.forEach((link) => {
            const aktiv = link.getAttribute('data-ziel') === id;
            link.setAttribute('aria-selected', aktiv ? 'true' : 'false');
            link.tabIndex = aktiv ? 0 : -1;
            if (aktiv) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          if (scrollen === 'nie') return;
          const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
          const haftet = this.getBoundingClientRect().top <= header + 2;
          if (scrollen === 'immer' || haftet) {
            const panel = document.getElementById(id);
            if (panel) panel.scrollIntoView({ block: 'start' });
          }
        }

        ankerStarten() {
          if (!this.panels.length || !('IntersectionObserver' in window)) return;
          this.sichtbar = new Set();
          this.observer = new IntersectionObserver(
            (eintraege) => {
              eintraege.forEach((e) => {
                if (e.isIntersecting) this.sichtbar.add(e.target.id);
                else this.sichtbar.delete(e.target.id);
              });
              const aktiv = this.panels.find((z) => this.sichtbar.has(z.id));
              this.links.forEach((link) => {
                const ist = aktiv && link.getAttribute('data-ziel') === aktiv.id;
                if (ist) link.setAttribute('aria-current', 'true');
                else link.removeAttribute('aria-current');
              });
            },
            { rootMargin: '-45% 0px -45% 0px' }
          );
          this.panels.forEach((z) => this.observer.observe(z));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-set-schritte"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-set-schritte')) {
    customElements.define(
      'custom-set-schritte',
      class extends HTMLElement {
        connectedCallback() {
          this.schritte = Array.from(this.querySelectorAll('.custom-set-schritte__schritt'));
          this.buehne = this.querySelector('.custom-set-schritte__buehne');
          if (!this.buehne || this.schritte.length < 2 || !('IntersectionObserver' in window)) return;
          // Buehnenbilder = Klone der Schrittbilder. Fehlt eines, bleibt die
          // einfache Reihe — eine Buehne mit Luecke waere schlechter.
          this.bilder = this.schritte.map((schritt) => {
            const img = schritt.querySelector('.custom-set-schritte__bild img');
            if (!img) return null;
            const klon = img.cloneNode(true);
            klon.removeAttribute('loading');
            klon.className = 'custom-set-schritte__buehne-bild';
            return klon;
          });
          if (this.bilder.some((b) => !b)) return;
          this.bilder.forEach((b) => this.buehne.appendChild(b));
          this.classList.add('is-scrolly');
          this.aktiv = -1;
          this.setzeAktiv(0);
          // Aktiv ist der Schritt, der die Fenstermitte schneidet. Gerechnet
          // wird aus den Rechtecken beim Scrollen (Capture, weil Horizon ab
          // 990px den .page-wrapper scrollt und scroll nicht nach oben
          // blubbert), hoechstens einmal je Frame. Zusaetzlich meldet ein
          // IntersectionObserver Wechsel, falls kein Scroll-Ereignis kommt
          // (Sprung per Anker, Groessenaenderung).
          // Synchron, ohne requestAnimationFrame: drei Rechtecke lesen kostet
          // nichts, und so haengt der Wechsel nicht am Frame-Takt.
          this.pruefen = () => {
            {
              // Bezugslinie: die Fenstermitte. Liegt die Buehne ueber den
              // Schritten (Handy, volle Breite), verdeckt sie die Mitte — dann
              // zaehlt die Linie kurz unter der Buehnenunterkante, sonst waere
              // der aktive Schritt hinter dem Bild.
              let mitte = window.innerHeight * 0.5;
              const b = this.buehne.getBoundingClientRect();
              if (b.width >= this.clientWidth * 0.8 && b.bottom > mitte - 40) {
                mitte = Math.min(b.bottom + 72, window.innerHeight - 48);
              }
              let treffer = -1;
              this.schritte.forEach((schritt, i) => {
                const r = schritt.getBoundingClientRect();
                if (r.top <= mitte && r.bottom > mitte) treffer = i;
              });
              if (treffer < 0) {
                // Zwischen den Schritten oder ausserhalb: vor dem ersten der erste,
                // nach dem letzten der letzte, sonst der letzte oberhalb der Mitte.
                const erster = this.schritte[0].getBoundingClientRect();
                const letzter = this.schritte[this.schritte.length - 1].getBoundingClientRect();
                if (erster.top > mitte) treffer = 0;
                else if (letzter.bottom <= mitte) treffer = this.schritte.length - 1;
                else {
                  this.schritte.forEach((schritt, i) => {
                    if (schritt.getBoundingClientRect().top <= mitte) treffer = i;
                  });
                }
              }
              this.setzeAktiv(treffer);
            }
          };
          // Auslauf unter dem letzten Schritt (Mathias 28.10.: beim dritten
          // Schritt schob sich das Bild sofort weg). Die klebende Buehne endet
          // mit der Liste; der letzte Schritt war kuerzer als das Bild, die Liste
          // endete also schon, als er die Bezugslinie erreichte. Jetzt reicht die
          // Liste so weit, dass das Bild stehen bleibt, bis der letzte Schritt
          // mittig auf der Linie steht. Handy: Linie liegt unter der Buehne, kein Auslauf.
          this.liste = this.querySelector('.custom-set-schritte__liste');
          this.polstern = () => {
            const hoehe = this.buehne.getBoundingClientRect().height;
            const oben = parseFloat(getComputedStyle(this.buehne).top) || 0;
            let mitte = window.innerHeight * 0.5;
            if (this.buehne.offsetWidth >= this.clientWidth * 0.8) {
              mitte = Math.min(oben + hoehe + 72, window.innerHeight - 48);
            }
            const letzter = this.schritte[this.schritte.length - 1];
            const auslauf = oben + hoehe - mitte - letzter.offsetHeight / 2;
            this.liste.style.paddingBottom = auslauf > 0 ? `${Math.ceil(auslauf)}px` : '';
          };
          this.beiGroesse = () => {
            this.polstern();
            this.pruefen();
          };
          this.polstern();
          document.addEventListener('scroll', this.pruefen, { capture: true, passive: true });
          window.addEventListener('resize', this.beiGroesse);
          this.observer = new IntersectionObserver(() => this.pruefen(), { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
          this.schritte.forEach((s) => this.observer.observe(s));
          this.pruefen();
        }

        setzeAktiv(i) {
          if (i === this.aktiv) return;
          this.aktiv = i;
          this.schritte.forEach((s, n) => s.classList.toggle('is-aktiv', n === i));
          this.bilder.forEach((b, n) => b.classList.toggle('is-aktiv', n === i));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.pruefen) {
            document.removeEventListener('scroll', this.pruefen, { capture: true });
            window.removeEventListener('resize', this.beiGroesse);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-sticky-buy-bar')) {
    customElements.define(
      'custom-sticky-buy-bar',
      class extends HTMLElement {
        connectedCallback() {
          // 2026-09-08, Mobil-Optimierung: Beobachtet wird das KAUFFORMULAR
          // (Knopf samt Mengenwaehler), nicht mehr die ganze Kaufbox.
          //
          // Die Kaufbox ist auf dem Telefon 1356px hoch (gemessen 375x812) und
          // damit fast zwei Bildschirme lang im Sichtfenster. Solange sie
          // irgendwo hineinragte, blieb die Leiste versteckt — auch dann, wenn
          // der Kaufknopf selbst laengst ausser Sicht war. Vor dem Knopf (Banner,
          // Galerie, Titel, Preis) gab es auf dem Telefon also KEINEN sichtbaren
          // Weg in den Warenkorb, danach erst ab 2285px wieder.
          //
          // Mit dem Formular als Anker gilt: Knopf im Bild -> Leiste weg, Knopf
          // nicht im Bild (darueber ODER darunter) -> Leiste da. Auf dem Telefon
          // ist der Kaufknopf damit vom ersten Bildschirm an erreichbar. Am
          // Rechner aendert sich fast nichts: Dort ist der Knopf im ersten
          // Bildschirm sichtbar und die Leiste erscheint wie bisher beim
          // Weiterscrollen. Die Kaufbox bleibt als Rueckfall fuer Vorlagen ohne
          // das Formular-Element.
          // Set-Vorlage (19.10.): Ihr Kaufbereich markiert das Formular mit
          // data-custom-buyform statt mit einer Hero-Klasse.
          const buybox =
            document.querySelector('[data-custom-buybox] [data-custom-buyform]') ||
            document.querySelector('[data-custom-buybox] .custom-pdp-hero__form') ||
            document.querySelector('[data-custom-buybox]');
          if (!buybox || !('IntersectionObserver' in window)) {
            this.removeAttribute('hidden');
            return;
          }
          // 2026-10-06: Am Rechner (ab 990px) liegt der Kaufknopf inzwischen
          // unter dem ersten Bildschirm. Die Leiste erschien dort schon ganz oben
          // und doppelte den Knopf. Am Rechner deshalb erst, wenn der Knopf nach
          // OBEN aus dem Bild gescrollt ist; auf dem Telefon wie bisher auch davor.
          // Der Observer meldet nur Wechsel zwischen „im Bild" und „nicht im Bild".
          // Springt man von oben direkt über den Knopf hinweg (unter dem Bild ->
          // über dem Bild), kommt keine Meldung; darum zusätzlich beim Scrollen
          // nachsehen (nur Lesen der Position, kein Layout-Schreiben).
          // 2026-10-11 (Mathias): Auch auf dem Telefon erst, wenn der Knopf nach OBEN aus
          // dem Bild ist. Die Leiste vom ersten Bildschirm an (Stand 08.09.) wirkte wie ein
          // zweiter Kaufknopf, bevor man Preis und Produkt überhaupt gesehen hat. Das alte
          // Verhalten bleibt als Section-Schalter „Auf dem Handy schon vor dem Kaufknopf".
          const handy = window.matchMedia('(max-width: 989px)');
          const handyVorab = this.hasAttribute('data-handy-vorab');
          const pruefen = () => {
            const r = buybox.getBoundingClientRect();
            const imBild = r.bottom > 0 && r.top < window.innerHeight;
            const darueber = r.bottom <= 0;
            const vorabErlaubt = handyVorab && handy.matches;
            this.toggleAttribute('hidden', imBild || (!vorabErlaubt && !darueber));
          };
          this.observer = new IntersectionObserver(pruefen, { rootMargin: '0px 0px 0px 0px' });
          this.observer.observe(buybox);
          this.pruefen = pruefen;
          window.addEventListener('scroll', pruefen, { passive: true });
          handy.addEventListener('change', pruefen);
          this.handy = handy;
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.pruefen) {
            window.removeEventListener('scroll', this.pruefen);
            this.handy.removeEventListener('change', this.pruefen);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prx-konfigurator"] && !Shopify.designMode) return;
  try {
    
  const PRX_V = 900; // virtuelle Bildkantenlänge, in der die Anker gerechnet sind

  // Gezeichnete Icons statt Unicode-Glyphen: „↑" und „✕" wechseln Form und
  // Strichstärke mit der Schriftart, diese Pfade bleiben auf jeder Plattform
  // dieselbe Linie (1.75er-Strich, runde Kappen, 16er-Raster).
  const PRX_ICONS = {
    hoch: '<path d="M8 13V3M3.5 7.5 8 3l4.5 4.5"/>',
    runter: '<path d="M8 3v10M3.5 8.5 8 13l4.5-4.5"/>',
    entfernen: '<path d="M4 4l8 8M12 4l-8 8"/>',
    plus: '<path d="M8 3v10M3 8h10"/>',
  };

  function prxIcon(name) {
    return `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PRX_ICONS[name]}</svg>`;
  }

  class PrxKonfigurator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.prxBereit) return;
      this.dataset.prxBereit = 'true';

      try {
        this.katalog = JSON.parse(this.querySelector('[data-prx-daten]').textContent);
      } catch (fehler) {
        console.warn('[prx-konfigurator] Daten nicht lesbar:', fehler);
        return;
      }

      // Eine Liste: Basen zuerst, dann Module von groß nach klein. Bewusst hier
      // sortiert und nicht über die Collection — so hängt die Reihenfolge nicht
      // daran, wie jemand die Collection zusammenklickt.
      this.katalog.sort((a, b) => {
        const rolle = (x) => (x.cfg.stapelrolle === 'basis' ? 0 : 1);
        return rolle(a) - rolle(b) || Number(b.cfg.masse_cm.h) - Number(a.cfg.masse_cm.h);
      });

      this.maxHoehe = Number(this.dataset.maxHoehe) || 150;

      this.geld = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: this.dataset.waehrung || 'EUR',
      });

      // Der Aufbau von unten nach oben. Eine Basis, falls vorhanden, liegt immer
      // auf Position 0 — darum kümmert sich hinzufuegen().
      this.teile = [];

      this.el = {
        buehne: this.querySelector('[data-prx-buehne]'),
        leer: this.querySelector('[data-prx-leer]'),
        mass: this.querySelector('[data-prx-mass]'),
        module: this.querySelector('[data-prx-module]'),
        stapel: this.querySelector('[data-prx-stapel]'),
        notiz: this.querySelector('[data-prx-notiz]'),
        anzahl: this.querySelector('[data-prx-anzahl]'),
        hoehe: this.querySelector('[data-prx-hoehe]'),
        flaeche: this.querySelector('[data-prx-flaeche]'),
        preis: this.querySelector('[data-prx-preis]'),
        add: this.querySelector('[data-prx-add]'),
        reset: this.querySelector('[data-prx-reset]'),
      };

      this.el.add.addEventListener('click', () => this.inDenWarenkorb());
      this.el.reset.addEventListener('click', () => {
        this.teile = [];
        this.alles();
      });

      this.beiResize = this.entprellt(() => this.zeichneBuehne(), 120);
      window.addEventListener('resize', this.beiResize);

      this.alles();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.beiResize);
    }

    entprellt(fn, ms) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    // --- Ableitungen -------------------------------------------------------

    aufbau() {
      return this.teile;
    }

    istBasis(artikel) {
      return artikel.cfg.stapelrolle === 'basis';
    }

    hatBasis() {
      return this.teile.length > 0 && this.istBasis(this.teile[0]);
    }

    // Ab diesem Index darf umsortiert werden — eine Basis bleibt unten.
    ersteFreie() {
      return this.hatBasis() ? 1 : 0;
    }

    hinzufuegen(artikel) {
      if (this.istBasis(artikel)) {
        if (this.hatBasis()) return;
        this.teile.unshift(artikel);
      } else {
        if (!this.stapelbar()) return;
        this.teile.push(artikel);
      }
      this.alles(artikel);
    }

    // Eine Basis trägt die nächste Lage nicht auf ihrer vollen Bauhöhe: beim
    // Trolley steckt im Maß der ausgefahrene Griff. Wo `stapelhoehe_cm` gesetzt
    // ist, zählt die statt masse_cm.h.
    gesamtHoehe() {
      return this.aufbau().reduce((s, a) => s + Number(a.cfg.stapelhoehe_cm ?? a.cfg.masse_cm.h), 0);
    }

    summe() {
      return this.aufbau().reduce((s, a) => s + a.preis, 0);
    }

    grundflaeche() {
      const teile = this.aufbau();
      if (!teile.length) return null;
      const l = Math.max(...teile.map((a) => Number(a.cfg.masse_cm.l)));
      const b = Math.max(...teile.map((a) => Number(a.cfg.masse_cm.b)));
      return `${this.zahl(l)} × ${this.zahl(b)} cm`;
    }

    // Nur stapeln, wenn das oberste Teil das zulässt.
    stapelbar() {
      const teile = this.aufbau();
      return teile.length ? teile[teile.length - 1].cfg.stapelbar_oben !== false : true;
    }

    zahl(n) {
      return n.toLocaleString(document.documentElement.lang || 'de-DE', { maximumFractionDigits: 1 });
    }

    cm(n) {
      return `${n.toLocaleString(document.documentElement.lang || 'de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })} cm`;
    }

    // --- Bühne -------------------------------------------------------------

    zeichneBuehne(neu) {
      this.el.buehne.querySelectorAll('img').forEach((n) => n.remove());

      const teile = this.aufbau();
      this.el.leer.hidden = teile.length > 0;
      this.el.mass.textContent = '';
      if (!teile.length) return;

      // Jedes Teil setzt mit seinem anchor auf dem top-Punkt des Teils darunter
      // auf. Half-Size-Teile belegen über slots mehrere Plätze nebeneinander.
      //
      // scale gleicht aus, dass nicht jeder Render im selben Maßstab vorliegt:
      // Rollbrett und Organizer S kamen etwas größer bzw. kleiner aus der
      // Bildbearbeitung. Alle Anker sind Anteile der jeweils eigenen Bildkante,
      // deshalb wird hier mit der Zeichengröße des Teils gerechnet, nicht mit PRX_V.
      let ax = PRX_V / 2;
      let ay = PRX_V;
      const platz = [];

      for (const artikel of teile) {
        const c = artikel.cfg;
        const groesse = PRX_V * (Number(c.scale) || 1);
        const left = ax - c.anchor[0] * groesse;
        const top = ay - c.anchor[1] * groesse;
        // Slot-Versatz bleibt in Bühnen-Einheiten — er beschreibt den Abstand
        // zweier Teile zueinander, nicht etwas im Bild.
        for (const slot of c.slots || [[0, 0]]) {
          platz.push({ artikel, groesse, left: left + slot[0] * PRX_V, top: top + slot[1] * PRX_V });
        }
        ax = left + c.top[0] * groesse;
        ay = top + c.top[1] * groesse;
      }

      // Enge Grenzen über den sichtbaren Bildinhalt, sonst wirkt der Stapel
      // klein — die Renders haben viel transparenten Rand.
      let x0 = Infinity;
      let y0 = Infinity;
      let x1 = -Infinity;
      let y1 = -Infinity;

      for (const p of platz) {
        const box = p.artikel.cfg.box || [0, 0, 1, 1];
        x0 = Math.min(x0, p.left + box[0] * p.groesse);
        y0 = Math.min(y0, p.top + box[1] * p.groesse);
        x1 = Math.max(x1, p.left + box[2] * p.groesse);
        y1 = Math.max(y1, p.top + box[3] * p.groesse);
      }

      const W = this.el.buehne.clientWidth;
      const H = this.el.buehne.clientHeight;
      const rand = 28;
      const sc = Math.min((W - 2 * rand) / (x1 - x0), (H - 2 * rand) / (y1 - y0));
      const ox = (W - (x1 - x0) * sc) / 2 - x0 * sc;
      const oy = (H - (y1 - y0) * sc) / 2 - y0 * sc;

      platz.forEach((p, i) => {
        const img = document.createElement('img');
        img.src = p.artikel.bild;
        img.alt = '';
        img.width = PRX_V;
        img.height = PRX_V;
        img.style.width = `${p.groesse * sc}px`;
        img.style.height = `${p.groesse * sc}px`;
        img.style.left = `${p.left * sc + ox}px`;
        img.style.top = `${p.top * sc + oy}px`;
        img.style.zIndex = String(10 + i); // höher liegende Teile verdecken
        if (neu && p.artikel === neu) {
          img.classList.add('prx--neu');
          requestAnimationFrame(() => requestAnimationFrame(() => img.classList.remove('prx--neu')));
        }
        this.el.buehne.appendChild(img);
      });

      this.el.mass.innerHTML = `<strong>${this.cm(this.gesamtHoehe())}</strong> hoch<br>${this.grundflaeche()}`;
    }

    // --- Bausteinliste -----------------------------------------------------

    zeichneModule() {
      this.el.module.textContent = '';
      const offen = this.stapelbar();

      for (const artikel of this.katalog) {
        const c = artikel.cfg;
        const basis = this.istBasis(artikel);

        // Eine Basis geht auch dann noch, wenn oben schon abgeschlossen ist —
        // sie rutscht ja nach unten.
        const gesperrt = artikel.verfuegbar === false || (basis ? this.hatBasis() : !offen);

        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'prx__modul';
        b.disabled = gesperrt;
        b.setAttribute('aria-label', `Hinzufügen: ${artikel.name}`);
        if (basis && this.hatBasis()) b.title = 'Es kann nur eine rollende Basis geben.';

        const marke = basis ? '<span class="prx__rolle">Basis</span>' : '';
        const stueck = c.stueck_je_artikel > 1 ? `${c.stueck_je_artikel} Stk. · ` : '';
        const inklusive = c.enthaelt && c.enthaelt.length ? `inkl. ${c.enthaelt.join(', ')} · ` : '';

        b.innerHTML = `
          <img src="${artikel.bild}" alt="" width="56" height="56" loading="lazy">
          <span>
            <span class="prx__modul-name">${marke}${artikel.name}</span>
            <span class="prx__modul-meta">${inklusive}${stueck}${this.zahl(c.masse_cm.l)} × ${this.zahl(
              c.masse_cm.b
            )} × ${this.zahl(c.masse_cm.h)} cm</span>
          </span>
          <span class="prx__modul-preis">${this.geld.format(artikel.preis / 100)}</span>
          <span class="prx__modul-plus" aria-hidden="true">${prxIcon('plus')}</span>`;

        b.addEventListener('click', () => this.hinzufuegen(artikel));

        this.el.module.appendChild(b);
      }
    }

    // --- Aufbau ------------------------------------------------------------

    zeichneStapel() {
      this.el.stapel.textContent = '';
      const teile = this.aufbau();

      if (!teile.length) {
        const li = document.createElement('li');
        li.className = 'prx__notiz';
        li.textContent = 'Noch keine Teile gewählt.';
        this.el.stapel.appendChild(li);
        return;
      }

      const untersteFreie = this.ersteFreie();

      // Von oben nach unten — so, wie der Stapel aussieht.
      for (let i = teile.length - 1; i >= 0; i--) {
        const artikel = teile[i];
        const c = artikel.cfg;
        const basis = this.istBasis(artikel);

        const li = document.createElement('li');
        li.className = 'prx__lage';

        const inklusive = c.enthaelt && c.enthaelt.length ? `inkl. ${c.enthaelt.join(', ')} · ` : '';
        const teilStueck = c.slots ? `${c.slots.length}× nebeneinander · ` : '';

        li.innerHTML = `
          <img src="${artikel.bild}" alt="" width="40" height="40" loading="lazy">
          <span>
            <span class="prx__lage-name">${basis ? '<span class="prx__rolle">Basis</span>' : ''}${
              artikel.name
            }</span>
            <span class="prx__lage-meta">${inklusive}${teilStueck}${this.cm(
              Number(c.masse_cm.h)
            )} · ${this.geld.format(artikel.preis / 100)}</span>
          </span>`;

        const tools = document.createElement('span');
        tools.className = 'prx__lage-tools';

        // Die Basis bleibt unten, deshalb keine Pfeile — entfernen geht trotzdem.
        if (!basis) {
          tools.append(
            this.werkzeug('hoch', 'Nach oben', i >= teile.length - 1, () => this.tausche(i, i + 1)),
            this.werkzeug('runter', 'Nach unten', i <= untersteFreie, () => this.tausche(i, i - 1))
          );
        }

        tools.append(
          this.werkzeug('entfernen', `Entfernen: ${artikel.name}`, false, () => {
            this.teile.splice(i, 1);
            this.alles();
          })
        );

        li.appendChild(tools);
        this.el.stapel.appendChild(li);
      }
    }

    werkzeug(icon, label, gesperrt, beiKlick) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'prx__ikon';
      b.innerHTML = prxIcon(icon);
      b.title = label;
      b.setAttribute('aria-label', label);
      b.disabled = gesperrt;
      b.addEventListener('click', beiKlick);
      return b;
    }

    // Tauschen nur, wenn danach kein abschließendes Teil unter einem anderen liegt
    // und die Basis unten bleibt.
    tausche(a, b) {
      if (a < this.ersteFreie() || b < this.ersteFreie()) return;

      const m = [...this.teile];
      [m[a], m[b]] = [m[b], m[a]];

      const verletzt = m.some((art, i) => art.cfg.stapelbar_oben === false && i < m.length - 1);
      if (verletzt) {
        this.el.notiz.textContent = `${m[b].name} muss oben bleiben — darauf lässt sich nichts stapeln.`;
        return;
      }

      this.teile = m;
      this.alles();
    }

    // --- Hinweise und Summe ------------------------------------------------

    zeichneNotiz() {
      const teile = this.aufbau();
      if (!teile.length) {
        this.el.notiz.textContent = '';
        return;
      }
      const oben = teile[teile.length - 1];
      if (!this.stapelbar()) {
        this.el.notiz.textContent = `Oben sitzt ${oben.name} — darauf lässt sich nichts weiter stapeln.`;
      } else if (this.gesamtHoehe() > this.maxHoehe) {
        this.el.notiz.textContent = `Über ${this.maxHoehe} cm wird der Stapel unhandlich. Für den Transport eher aufteilen.`;
      } else {
        this.el.notiz.textContent = '';
      }
    }

    zeichneSumme() {
      const teile = this.aufbau();
      this.el.anzahl.textContent = String(teile.length);
      this.el.hoehe.textContent = teile.length ? this.cm(this.gesamtHoehe()) : '—';
      this.el.flaeche.textContent = this.grundflaeche() || '—';
      this.el.preis.textContent = this.geld.format(this.summe() / 100);
      this.el.add.disabled = teile.length === 0;
    }

    alles(neu) {
      this.zeichneBuehne(neu);
      this.zeichneModule();
      this.zeichneStapel();
      this.zeichneNotiz();
      this.zeichneSumme();
    }

    // --- Warenkorb ---------------------------------------------------------

    zeilen() {
      const zaehler = new Map();
      for (const artikel of this.aufbau()) {
        zaehler.set(artikel.id, (zaehler.get(artikel.id) || 0) + 1);
      }
      return [...zaehler].map(([id, quantity]) => ({ id, quantity }));
    }

    async inDenWarenkorb() {
      const zeilen = this.zeilen();
      if (!zeilen.length) return;

      this.el.add.disabled = true;

      // Bevorzugt die Standard-Action: sie stößt die Warenkorb-Ereignisse an,
      // also aktualisieren sich Schublade und Zähler im Header von selbst.
      const updateCart = window.Shopify?.actions?.updateCart;

      if (typeof updateCart === 'function') {
        try {
          await updateCart({
            action: 'add',
            lines: zeilen.map((z) => ({ merchandiseId: z.id, quantity: z.quantity })),
          });
          window.Shopify?.actions?.openCart?.();
          this.el.add.disabled = false;
          return;
        } catch (fehler) {
          console.warn('[prx-konfigurator] Standard-Action fehlgeschlagen, nutze AJAX-Route:', fehler);
        }
      }

      try {
        const antwort = await fetch(`${this.dataset.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: zeilen }),
        });
        if (!antwort.ok) throw new Error(await antwort.text());
        window.location.href = this.dataset.cartUrl;
      } catch (fehler) {
        console.error('[prx-konfigurator] Warenkorb:', fehler);
        this.el.notiz.textContent = 'Der Aufbau ließ sich nicht in den Warenkorb legen. Bitte erneut versuchen.';
        this.el.add.disabled = false;
      }
    }
  }

  if (!customElements.get('prx-konfigurator')) {
    customElements.define('prx-konfigurator', PrxKonfigurator);
  }

  } catch(e) { console.error(e); }
})();
})();
